import { withAuthenticationRequired } from "@auth0/auth0-react";
import { store } from "../store";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import APIKeysTable from "../components/tables/APIKeys";

function APIKeys() {
  const { t } = useTranslation("common");
  const userDB = useSelector((state) => state.userDB);

  useEffect(() => {
    store.dispatch({
      type: "pageTitle/update",
      payload: "API Keys",
    });

    let pageActions = [];

    if (userDB.admin) {
      pageActions = [
        {
          name: "Create New API Key",
          icon: "Add",
          url: "/add/api-key",
        },
      ];
    }

    store.dispatch({ type: "pageActions/update", payload: pageActions });
  }, [t, userDB.admin]);

  return (
    <Grid item xs={12}>
      <APIKeysTable />
    </Grid>
  );
}

export default withAuthenticationRequired(APIKeys);
